import React, { useEffect, useState } from "react";
import {
  IconTrendingUp, IconUsers, IconUserPlus, IconCrown,
  IconTarget, IconCurrencyDollar, IconReceipt2, IconCalendar, IconCheck,
} from "@tabler/icons-react";
import BlockSection, { KPISubgroup } from "./BlockSection";
import KPICard from "./KPICard";
import InsightsChart from "./InsightsChart";
import { fetchGrowth, exportInsightsXLSX } from "../services";
import { ACQUISITION_CHANNEL_LABELS } from "../../../jsx/components/ContactsBoard/constants";

const SOURCE_LABELS = { whatsapp: "WhatsApp", manual: "Manual", import: "Importação", api: "API" };
const CHANNEL_LABELS = { ...ACQUISITION_CHANNEL_LABELS, unspecified: "Não informado" };

const GrowthBlock = ({ filters }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = async () => {
    setLoading(true); setError(null);
    try {
      const d = await fetchGrowth(filters);
      setData(d);
    } catch (e) {
      setError("Não foi possível carregar este bloco.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); /* eslint-disable-line */ }, [filters]);

  const k = data?.kpis || {};
  const trend = data?.charts?.monthly_trend;
  const sources = data?.charts?.sources_distribution;
  const channels = data?.charts?.acquisition_channels;
  const revenueExplanation = data?.metadata?.revenue_explanation;

  const labelize = (raw, dict) => raw.map((s) => dict[s] || s);

  return (
    <BlockSection
      title="Meu negócio está crescendo?"
      subtitle="Volume, conversões e receita realizada no período"
      icon={IconTrendingUp}
      color="linear-gradient(135deg, #137ff7, #1ea7c5)"
      loading={loading}
      error={error}
      onRetry={load}
      onExport={() => exportInsightsXLSX("growth", filters)}
    >
      <KPISubgroup title="Receita" icon={IconCurrencyDollar} color="#16a34a">
        <KPICard
          label="Receita Realizada"
          kpi={k.revenue_total}
          icon={IconCurrencyDollar}
          color="linear-gradient(135deg, #16a34a, #15803d)"
          hint={revenueExplanation}
        />
        <KPICard
          label="Receita de Agendamentos"
          kpi={k.revenue_events}
          icon={IconReceipt2}
        />
        <KPICard
          label="Receita de Deals Ganhos (CRM)"
          kpi={k.revenue_won}
          icon={IconCrown}
        />
        <KPICard
          label="Ticket Médio"
          kpi={k.avg_ticket}
          icon={IconTarget}
        />
      </KPISubgroup>

      <KPISubgroup title="CRM — Contatos e Conversão" icon={IconUsers} color="#a855f7">
        <KPICard
          label="Conversas Únicas"
          kpi={k.unique_conversations}
          icon={IconUsers}
        />
        <KPICard
          label="Novos Contatos"
          kpi={k.new_contacts}
          icon={IconUserPlus}
        />
        <KPICard
          label="Novos Clientes (Conversões)"
          kpi={k.new_customers}
          icon={IconCrown}
          color="linear-gradient(135deg, #16a34a, #15803d)"
          hint="Contatos convertidos em cliente neste período"
        />
        <KPICard
          label="Taxa de Conversão"
          kpi={k.conversion_rate}
          icon={IconTarget}
          hint="Dos contatos criados no período, % que viraram cliente (cohort honesto)"
        />
      </KPISubgroup>

      <KPISubgroup title="Agendamentos" icon={IconCalendar} color="#137ff7">
        <KPICard
          label="Total Agendamentos"
          kpi={k.total_appointments}
          icon={IconCalendar}
        />
        <KPICard
          label="Confirmados"
          kpi={k.confirmed_appointments}
          icon={IconCheck}
        />
      </KPISubgroup>

      <div className="insights-charts-row">
        {trend?.series?.length > 0 && (
          <div className="insights-chart insights-chart--wide">
            <div className="insights-chart__head"><h3>Tendência mensal (últimos 6 meses)</h3></div>
            <InsightsChart
              type="line"
              categories={trend.categories || []}
              series={trend.series || []}
              colors={["#137ff7", "#f59e0b", "#16a34a"]}
            />
          </div>
        )}
        {sources?.series?.length > 0 && (
          <div className="insights-chart">
            <div className="insights-chart__head"><h3>Origem dos contatos</h3></div>
            <InsightsChart
              type="donut"
              labels={labelize(sources.labels, SOURCE_LABELS)}
              series={sources.series || []}
              colors={["#2bc155", "#137ff7", "#f59e0b", "#a855f7"]}
            />
          </div>
        )}
        {channels?.series?.length > 0 && (
          <div className="insights-chart">
            <div className="insights-chart__head"><h3>Canal de aquisição</h3></div>
            <InsightsChart
              type="donut"
              labels={labelize(channels.labels, CHANNEL_LABELS)}
              series={channels.series || []}
              colors={["#16a34a", "#a855f7", "#f59e0b", "#137ff7", "#ef4444"]}
            />
          </div>
        )}
      </div>
    </BlockSection>
  );
};

export default GrowthBlock;
